const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  language: state => state.app.language,
  screenSize: state => state.app.screenSize,
  // ...其他配置项省略...
}
export default getters





// WEBPACK FOOTER //
// ./src/store/getters.js